import { del, get, post, put } from "helpers/api_helper/Authentication/authenticationApiHelper"
import * as url from "helpers/url_helper/url_helper"


export const getUserRoleRelations = () => get(url.USER_ROLE_DEFINITION_DEFINITIONS)
export const addUserRoleRelation = userRoleRelation => post(url.USER_ROLE_DEFINITION_INSERT, userRoleRelation)
export const updateUserRoleRelation = userRoleRelation => put(url.USER_ROLE_DEFINITION_UPDATE, userRoleRelation)
export const deleteUserRoleRelation = guid => del(url.USER_ROLE_DEFINITION_DELETE, { params: { guid } })

